import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';

import EmailsIcon from '../../../../assets/icons/EmailTriggerIcon';
import ProductIcon from '../../../../assets/icons/ProductIcon';
import UsageIcon from '../../../../assets/icons/UsageIcon';
import ResupplyIcon from '../../../../assets/icons/ResupplyIcon';
import OverdueIcon from '../../../../assets/icons/OverdueCountIcon';
import ItemIcon from '../../../../assets/icons/ItemIcon';

import { routes } from '../../../../constants';

const options = [
  {
    title: 'Emails',
    subTitle: 'Manage email addresses',
    icon: <EmailsIcon className='option-icn' />,
    url: routes.EMAIL_NOTIFICATIONS
  },
  {
    title: 'Bookings',
    subTitle: 'Manage product email list',
    icon: <ProductIcon className='option-icn' />,
    url: routes.PRODUCT_NOTIFICATIONS
  },
  {
    title: 'Usage',
    subTitle: 'Manage usage products',
    icon: <UsageIcon className='option-icn' />,
    url: routes.USAGE_NOTIFICATIONS
  },
  {
    title: 'Resupply',
    subTitle: 'Manage resupply notifications',
    icon: <ResupplyIcon className='option-icn' />,
    url: routes.RESUPPLY_NOTIFICATIONS
  },
  {
    title: 'Overdue Shipping',
    subTitle: 'Manage overdue shipping notifications',
    icon: <OverdueIcon className='option-icn' />,
    url: routes.OVERDUE_SHIPPING_NOTIFICATIONS
  },
  {
    title: 'Expiring Stock',
    subTitle: 'Alert for expiring items in the next 3 months',
    icon: <ItemIcon className='option-icn' />,
    url: routes.EXPIRING_STOCK_NOTIFICATIONS
  },
];

const NotificationsPage = () => {
  const tenantColor = useSelector((state) => state.tenant.currentTenant.colorPrimary);

  return (
    <div className='page-container flex-1'>
      <div className='page-title'>
        Triggers
      </div>

      <div className='customers-page__body'>
        <Grid container spacing={1}>
          {
            options.map(option => (
              <Grid key={option.title} item xs={12} sm={12} md={4}>
                <Link to={option.url}>
                  <div
                    className='customers-page-option'
                    key={`${option.title}_${Math.random()}`}
                    style={{ '--colorHover': `${tenantColor}` }}
                  >
                    <span className='option-title'>{option.title}</span>
                    <span className='option-sub-t'>{option.subTitle}</span>
                    <div className='option-icn-cnt'>
                      <span>{React.cloneElement(option.icon, { color: 'var(--app-text)' })}</span>
                    </div>
                  </div>
                </Link>
              </Grid>
            ))
          }
        </Grid>
      </div>
    </div>
  );
};

export default NotificationsPage;
